module.exports = __webpack_public_path__ + "static/media/Ali_Avatar_Joker.adfb06f6.svg";